import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import './galery1.css';

const Gallery1 = ({
    resortName,
    imageUrls,
    onClose
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // Sample gallery data - replace with your actual images
  const galleryImages = imageUrls.map((url, i) => ({
    id: i + 1,
    title: `${resortName} - Photo ${i + 1}`,
    url: url,
    thumbUrl: url
  }));

  //console.log('Gallery1(): galleryImages:', JSON.stringify(galleryImages, null, 2));

  const goToPrevious = () => {
    setCurrentIndex(prev => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex(prev => (prev === galleryImages.length - 1 ? 0 : prev + 1));
  };

  const goToImage = (index) => {
    setCurrentIndex(index);
  };
  const handleClose = () => {
    if (onClose)
      onClose();
  };

  return (
    <div className="gallery-container">
      <div className="gallery-header">
        <h2>{resortName}</h2>
        <div className="gallery-counter">
          {currentIndex + 1} / {galleryImages.length}
        </div>
        <button className="close-button" onClick={onClose}>
          <FaTimes size={24} />
        </button>
      </div>

      <div className="gallery-content-wrapper">
        <div className="galery-main-image-container">
          <button className="nav-button prev" onClick={goToPrevious}>
            <FaChevronLeft size={24} />
          </button>
          
          <div className="galery-image-container">
            <img 
              src={galleryImages[currentIndex].url} 
              alt={galleryImages[currentIndex].title}
              onError={(e) => {
                e.target.src = 'https://via.placeholder.com/800x500?text=Photo+Not+Available';
              }}
            />
          </div>
          
          <button className="nav-button next" onClick={goToNext}>
            <FaChevronRight size={24} />
          </button>
        </div>

        <div className="thumbnails-container">
          <div className="thumbnails-scroll">
            {galleryImages.map((image, index) => (
              <div 
                key={image.id}
                className={`thumbnail ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToImage(index)}
              >
                <img 
                  src={image.thumbUrl} 
                  alt={`Thumb ${index + 1}`}
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/100x75?text=Thumb';
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery1;